export enum TimeRangeEnum {
  Last1Day = 'last_1_day',
  Last1Week = 'last_1_week',
  Last1Month = 'last_1_month',
  Last30Days = 'last_30_days',
  Last3Months = 'last_3_months',
  Last6Months = 'last_6_months',
  Last12Months = 'last_12_months',
}

export const getTimeRangeLabel = (timeRange: TimeRangeEnum): string => {
  switch (timeRange) {
    case TimeRangeEnum.Last1Day:
      return 'Yesterday (UTC)';
    case TimeRangeEnum.Last1Week:
      return 'Last Week';
    case TimeRangeEnum.Last1Month:
      return 'Last Month';
    case TimeRangeEnum.Last30Days:
      return 'Last 30 Days';
    case TimeRangeEnum.Last3Months:
      return 'Last 3 Months';
    case TimeRangeEnum.Last6Months:
      return 'Last 6 Months';
    case TimeRangeEnum.Last12Months:
      return 'Last 12 Months';
    default:
      return '';
  }
};
